import React from 'react';
import {
  Alert,
  List,
  Spacer,
  Stack,
  Text
} from '@efast_public/fjd-component-library';

interface MissingDataModelsAlertProps {
  readonly missingDataModels: Record<string, string[]>;
  readonly hasMissingModels: boolean;
}

const MissingDataModelsAlert: React.FC<MissingDataModelsAlertProps> = ({
  missingDataModels,
  hasMissingModels
}) => {
  if (!hasMissingModels) {
    return null;
  }

  return (
    <Alert
      variant="warning"
      message={
        <div>
          <Stack direction="column" size="m">
            <Text variant="warning" size="s" strong>
              Fehlende Datenmodelle
            </Text>
            <Spacer />
            <Text variant="warning" size="s">
              Die folgenden Datenmodelle fehlen und können hochgeladen werden:
            </Text>
            <Spacer size="xs" />
            <div>
              {Object.entries(missingDataModels).map(
                ([identifier, versions]) => (
                  <div key={identifier}>
                    <strong>{identifier}:</strong>
                    <List key={identifier}>
                      {versions.map((version, index) => (
                        <List.ListItem
                          key={index}
                          style={{
                            color: 'var(--fjd2-semantic-warning-color)',
                            fontSize: 'var(--fjd2-text-font-size)'
                          }}
                        >
                          <Text size="s" variant="warning">
                            {version}
                          </Text>
                        </List.ListItem>
                      ))}
                    </List>
                  </div>
                )
              )}
            </div>
          </Stack>
        </div>
      }
    />
  );
};

export default MissingDataModelsAlert;
